import { FC } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from './NotFound.module.scss';
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';

const NotFound: FC = () => {
  const navigate = useNavigate();

  const handleButtonClick = (): void => {
    navigate('/');
  };

  return (
    <div className={styles.notFound}>
      <h1>{'Page or asset data not found'}</h1>
      <ReportOutlinedIcon />
      <Button className={styles.button} variant="contained" onClick={handleButtonClick}>
        Back to Dashboard
      </Button>
    </div>
  );
};

export default NotFound;
